module.exports = __webpack_public_path__ + "img/menu.80581016.svg";